import setBreakpoint from './setBreakpoint.js';
import getBreakpoint from './getBreakpoint.js';

var breakpoints = {
  setBreakpoint,
  getBreakpoint
};

export { breakpoints as default };
//# sourceMappingURL=index.js.map
